export default __webpack_public_path__ + "static/media/Img.52872e8b.png";